document.addEventListener("DOMContentLoaded", () => {

	/* ======================================================
	   HELPERS
	====================================================== */

	function snapToCard(container, onSnap) {
		const cards = container.querySelectorAll(".br-grid-card");
		if (!cards.length) return;

		let closest = null;
		let closestDist = Infinity;
		const current = container.scrollLeft;

		cards.forEach((card) => {
			const dist = Math.abs(card.offsetLeft - current);
			if (dist < closestDist) { closestDist = dist; closest = card; }
		});

		if (!closest) return;
		container.scrollTo({ left: closest.offsetLeft, behavior: "smooth" });
		if (onSnap) onSnap(closest);
	}

	function enableDragScroll(container, { snap = true, onSnap = null } = {}) {
		let isDown = false;
		let startX = 0;
		let scrollLeft = 0;
		let lastX = 0;
		let lastTime = 0;
		let velocity = 0;
		let momentumFrame = null;

		function stopMomentum() {
			if (momentumFrame) cancelAnimationFrame(momentumFrame);
			momentumFrame = null;
		}

		function onMouseDown(e) {
			if (e.target.closest("a")) return;
			if (e.button !== 0) return;
			isDown = true;
			container.classList.add("is-dragging");
			startX = e.pageX;
			scrollLeft = container.scrollLeft;
			lastX = e.pageX;
			lastTime = performance.now();
			velocity = 0;
			stopMomentum();
		}

		function onMouseMove(e) {
			if (!isDown) return;
			e.preventDefault();
			const now = performance.now();
			velocity = (e.pageX - lastX) / (now - lastTime);
			container.scrollLeft = scrollLeft - (e.pageX - startX);
			lastX = e.pageX;
			lastTime = now;
		}

		function onMouseUp() {
			if (!isDown) return;
			isDown = false;
			container.classList.remove("is-dragging");
			startMomentum();
		}

		function onMouseLeave() {
			if (!isDown) return;
			isDown = false;
			container.classList.remove("is-dragging");
			startMomentum();
		}

		function startMomentum() {
			let v = velocity * 30;
			const friction = 0.90;

			function loop() {
				if (Math.abs(v) < 0.3) {
					if (snap) snapToCard(container, onSnap);
					return;
				}
				container.scrollLeft -= v;
				v *= friction;
				momentumFrame = requestAnimationFrame(loop);
			}
			loop();
		}

		function onWheel(e) {
			if (Math.abs(e.deltaY) > Math.abs(e.deltaX)) {
				e.preventDefault();
				container.scrollBy({ left: e.deltaY * 1.2, behavior: "smooth" });
			}
		}

		container.addEventListener("mousedown", onMouseDown);
		container.addEventListener("mousemove", onMouseMove);
		container.addEventListener("mouseup", onMouseUp);
		container.addEventListener("mouseleave", onMouseLeave);
		container.addEventListener("wheel", onWheel, { passive: false });
	}

	function buildCard(it) {
		const card = document.createElement("div");
		card.className = "br-grid-card";
		const inner   = it.url ? `<a href="${it.url}" ${it.newTab ? 'target="_blank" rel="noopener noreferrer"' : ""}>` : `<div class="no-link">`;
		const close   = it.url ? `</a>` : `</div>`;
		const showImg = it.showImage !== false && it.image;
		card.innerHTML = `
			${inner}
				${showImg ? `<img src="${it.image}" alt="">` : ""}
				<div class="content">
					${it.subtitle    ? `<span class="br-card-subtitle br-card-subtitle--${it.subtitleColor || "blue"}" style="font-style:${it.subtitleStyle || "normal"}">${it.subtitle}</span>` : ""}
					<h4>${it.title || ""}</h4>
					${it.description ? `<p class="br-card-description">${it.description}</p>` : ""}
					${it.year        ? `<p class="br-card-year">${it.year}</p>` : ""}
				</div>
			${close}`;
		return card;
	}

	function buildSlide(it) {
		const slide = document.createElement("div");
		slide.className = "br-slide";
		const inner   = it.url ? `<a href="${it.url}" ${it.newTab ? 'target="_blank" rel="noopener noreferrer"' : ""}>` : `<div class="no-link">`;
		const close   = it.url ? `</a>` : `</div>`;
		const showImg = it.showImage !== false && it.image;
		slide.innerHTML = `
			${inner}
				${showImg ? `<img src="${it.image}" alt="">` : ""}
				<div class="content">
					${it.subtitle    ? `<span class="br-card-subtitle br-card-subtitle--${it.subtitleColor || "blue"}" style="font-style:${it.subtitleStyle || "normal"}">${it.subtitle}</span>` : ""}
					<h4>${it.title || ""}</h4>
					${it.description ? `<p class="br-card-description">${it.description}</p>` : ""}
					${it.year        ? `<p class="br-card-year">${it.year}</p>` : ""}
				</div>
			${close}`;
		return slide;
	}

	/* ======================================================
	   CAROUSELS
	====================================================== */

	document.querySelectorAll(".br-page-carousel").forEach((carousel) => {

		const items         = JSON.parse(carousel.dataset.items || "[]");
		const autoplay      = carousel.dataset.autoplay === "true";
		const arrows        = carousel.dataset.arrows  === "true";
		const grid          = carousel.dataset.grid    === "true";
		const loopInfinite  = carousel.dataset.loop    === "true";
		const autoplayDelay = parseInt(carousel.dataset.delay, 10) || 4000;

		/* ======================================================
		   GRID MODE
		====================================================== */
		if (grid) {
			carousel.classList.add("br-grid-horizontal");

			const track = document.createElement("div");
			track.className = "br-grid-track";

			items.forEach((it) => track.appendChild(buildCard(it)));
			carousel.appendChild(track);

			const realCount = items.length;

			/* ── Infinite loop ─────────────────────────────────────
			   Layout: [BUFFER*n clones] [n real] [BUFFER*n clones]

			   BUFFER is sized so the clone stock is never exhausted
			   even with sustained rapid clicking. scrollend fires
			   only after the smooth scroll has truly stopped, so the
			   silent teleport back into the real zone is always
			   invisible to the user.
			──────────────────────────────────────────────────────── */

			let allDomCards;
			let currentCardIndex = 0;
			let realStart = 0;

			if (loopInfinite && realCount > 1) {

				/* Buffer: at least 5 copies, enough for ~50 rapid clicks */
				const BUFFER = Math.max(5, Math.ceil(50 / realCount));

				const realCards = Array.from(track.querySelectorAll(".br-grid-card"));

				/* Append BUFFER sets of after-clones */
				for (let b = 0; b < BUFFER; b++) {
					realCards.forEach((c) => track.appendChild(c.cloneNode(true)));
				}

				/* Prepend BUFFER sets of before-clones (reverse-insert keeps order) */
				for (let b = 0; b < BUFFER; b++) {
					for (let i = realCards.length - 1; i >= 0; i--) {
						track.insertBefore(realCards[i].cloneNode(true), track.firstChild);
					}
				}

				allDomCards  = Array.from(track.querySelectorAll(".br-grid-card"));
				realStart    = BUFFER * realCount;
				currentCardIndex = realStart;

				/* Start at first real card */
				requestAnimationFrame(() => {
					track.scrollLeft = allDomCards[realStart].offsetLeft;
				});

				/* ── Teleport: fires ONLY after smooth scroll fully stops ──

				   Problem with a debounce timer: a dropped frame can make
				   it fire mid-animation, causing a visible backward jump.

				   Solution: scrollend event (fires after animation ends).
				   Fallback for browsers without scrollend: 500ms debounce
				   (much safer margin than the old 150ms).
				──────────────────────────────────────────────────────── */

				const teleport = () => {
					if (currentCardIndex < realStart ||
					    currentCardIndex >= realStart + realCount) {
						const itemIdx    = ((currentCardIndex % realCount) + realCount) % realCount;
						const realDomIdx = realStart + itemIdx;
						if (allDomCards[realDomIdx]) {
							track.scrollLeft = allDomCards[realDomIdx].offsetLeft;
							currentCardIndex = realDomIdx;
						}
					}
				};

				const hasScrollEnd = "onscrollend" in track;

				if (hasScrollEnd) {
					/* scrollend: fires exactly when smooth scroll ends */
					track.addEventListener("scrollend", teleport);
				} else {
					/* Fallback: 500ms debounce — wide enough to clear any
					   smooth scroll animation even on slow devices */
					let fallback = null;
					track.addEventListener("scroll", () => {
						clearTimeout(fallback);
						fallback = setTimeout(teleport, 500);
					});
				}
			} else {
				allDomCards      = Array.from(track.querySelectorAll(".br-grid-card"));
				currentCardIndex = 0;
			}

			/* ── Navigate to a DOM card index ── */
			const goToCard = (idx) => {
				if (!allDomCards[idx]) return; /* buffer safety guard */
				currentCardIndex = idx;
				track.scrollTo({ left: allDomCards[idx].offsetLeft, behavior: "smooth" });
			};

			/* ── Progress bar (hidden in infinite mode) ── */
			if (!loopInfinite) {
				const progress = document.createElement("div");
				progress.className = "br-grid-progress";
				progress.innerHTML = `<div class="bar-bg"><div class="bar-fill"></div></div>`;
				carousel.appendChild(progress);

				const barFill = progress.querySelector(".bar-fill");
				const updateProgress = () => {
					const max = track.scrollWidth - track.clientWidth;
					barFill.style.width = max <= 0 ? "100%" :
						`${Math.min(100, Math.max(0, (track.scrollLeft / max) * 100))}%`;
				};
				track.addEventListener("scroll", updateProgress);
				updateProgress();
			}

			/* ── Arrows ── */
			if (arrows) {
				const controls = document.createElement("div");
				controls.className = "br-grid-controls";

				const prev = document.createElement("button");
				const next = document.createElement("button");
				prev.className = "br-grid-arrow prev";
				next.className = "br-grid-arrow next";
				prev.textContent = "‹";
				next.textContent = "›";

				if (loopInfinite) {
					prev.addEventListener("click", () => goToCard(currentCardIndex - 1));
					next.addEventListener("click", () => goToCard(currentCardIndex + 1));
				} else {
					const updateArrows = () => {
						const max = track.scrollWidth - track.clientWidth;
						prev.disabled = track.scrollLeft <= 0;
						next.disabled = track.scrollLeft >= max - 1;
					};
					track.addEventListener("scroll", updateArrows);
					updateArrows();
					prev.addEventListener("click", () => track.scrollBy({ left: -350, behavior: "smooth" }));
					next.addEventListener("click", () => track.scrollBy({ left:  350, behavior: "smooth" }));
				}

				controls.appendChild(prev);
				controls.appendChild(next);
				carousel.appendChild(controls);
			}

			/* ── Drag + snap ── */
			const onSnapCb = (loopInfinite && allDomCards.length > 0)
				? (card) => { currentCardIndex = allDomCards.indexOf(card); }
				: null;

			enableDragScroll(track, { snap: true, onSnap: onSnapCb });

			/* ── Autoplay (grid) ── */
			if (autoplay && realCount > 1) {
				let timer = setInterval(() => goToCard(currentCardIndex + 1), autoplayDelay);
				carousel.addEventListener("mouseenter", () => clearInterval(timer));
				carousel.addEventListener("mouseleave", () => {
					timer = setInterval(() => goToCard(currentCardIndex + 1), autoplayDelay);
				});
			}

			return;
		}

		/* ======================================================
		   CLASSIC SLIDE CAROUSEL
		====================================================== */

		const wrapper = document.createElement("div");
		wrapper.className = "br-carousel-track";
		items.forEach((it) => wrapper.appendChild(buildSlide(it)));
		carousel.appendChild(wrapper);

		let index = 0;
		const total = items.length;
		let prevBtn = null;
		let nextBtn = null;

		const updateArrows = () => {
			if (loopInfinite) return;
			if (prevBtn) prevBtn.disabled = index === 0;
			if (nextBtn) nextBtn.disabled = index === total - 1;
		};

		const goTo = (i) => {
			index = loopInfinite
				? ((i % total) + total) % total
				: Math.max(0, Math.min(i, total - 1));
			wrapper.style.transform = `translateX(-${index * 100}%)`;
			updateArrows();
		};

		if (arrows) {
			prevBtn = document.createElement("button");
			nextBtn = document.createElement("button");
			prevBtn.className = "br-arrow br-prev";
			nextBtn.className = "br-arrow br-next";
			prevBtn.textContent = "<";
			nextBtn.textContent = ">";
			prevBtn.addEventListener("click", () => goTo(index - 1));
			nextBtn.addEventListener("click", () => goTo(index + 1));
			carousel.appendChild(prevBtn);
			carousel.appendChild(nextBtn);
			updateArrows();
		}

		if (autoplay && total > 1) {
			let timer = setInterval(() => goTo(index + 1), autoplayDelay);
			carousel.addEventListener("mouseenter", () => clearInterval(timer));
			carousel.addEventListener("mouseleave", () => {
				timer = setInterval(() => goTo(index + 1), autoplayDelay);
			});
		}
	});
});
